<div mat-dialog-title>
  <div class="d-flex justify-content-between">
      <p>Shared History : {{doc_No}}</p>
      <i id="ibtClose" class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
  </div>
</div>
<div mat-dialog-content>
  <div class="row eip-mt-20 eip-ml-xs-10 eip-mr-xs-10">
      <div class="col-xl-12 col-lg-12 col-md-12 p-10">
          <div>
              <kendo-grid [kendoGridBinding]="selectedRepositoryHistory" [style.maxHeight]="540" [pageable]="true" [pageSize]="pageSize" [sortable]="false" [resizable]="true" [reorderable]="true" [filterable]="enableFilter" [selectable]="true" [scrollable]="false" class="form-group-grid auto-complete-equal k-resizable-grid kg-hover-icon">
                  <ng-template kendoPagerTemplate>
                      <div class="k-pager-left">
                          <kendo-pager-info></kendo-pager-info>
                      </div>
                      <div class="k-pager-right">
                          <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                          <kendo-pager-input></kendo-pager-input>
                          <kendo-pager-next-buttons></kendo-pager-next-buttons>
                      </div>
                  </ng-template>
                  <ng-template kendoGridToolbarTemplate>
                      <div class="k-grid-toolbar-content d-flex">
                          <div class="flex-grow-1 title-container">
                              <p class="title">Details</p>
                              <div class="pagination-container details-section">
                              </div>
                          </div>
                          <div class="flex-grow-1 mat-panel-headerbar"></div>
                          <div class="pagination-container">
                              <p id="lblShowDetails">Show</p>
                              <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                              </kendo-pager-page-sizes>
                              <span>Items</span>
                          </div>
                          <div class="divider-container d-none d-md-block" id="imgDivider">
                              <span></span>
                          </div>
                          <div class="icons-container">
                              <i class="fa fa-ellipsis-v d-block d-md-none" aria-hidden="true" [ngClass]="{'ellipsis-active' : toggleListIcons}" (click)="toggleListIcons = !toggleListIcons"></i>
                              <div class="d-none d-md-flex align-items-md-center" [ngClass]="{'icons-list-type' : toggleListIcons}">
                                  <div class="icon-wrap">
                                      <i class="fa fa-filter" title="Filter" (click)="toggleFilter()" aria-hidden="true"></i>
                                      <span class="list-icon-name">Filter</span>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </ng-template>
                  <kendo-grid-column title="Sl.No." width="60">
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                          {{rowIndex+1}}
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="assigned_By" title="Assigned By" width="60">
                      <ng-template kendoGridCellTemplate let-dataItem>
                          {{dataItem.assigned_By}}
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="assigned_To" title="Assigned To" width="60">
                      <ng-template kendoGridCellTemplate let-dataItem>
                          {{dataItem.assigned_To}}
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="Assigned_On" width="60" title="Assigned On">
                  </kendo-grid-column>
                  <kendo-grid-column field="viewStatus" title="View" width="30">
                      <ng-template kendoGridCellTemplate let-dataItem>
                          {{dataItem.viewStatus}}
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="viewed_On" title="Viewed On" width="60">
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                          {{dataItem.Date}}
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="communication" width="100" title="Communication">
                      <ng-template kendoGridCellTemplate let-dataItem>
                          <span class="no-wrap" eipTooltip="{{dataItem.communication}}" eipTooltipPosition="auto">
                              {{dataItem.communication}}
                          </span>
                      </ng-template>
                  </kendo-grid-column>
              </kendo-grid>
          </div>
      </div>
  </div>